import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import LoadingSpinner from "./components/LoadingSpinner";
import ScrollToTop from "./components/ScrollToTop";

const queryClient = new QueryClient();

const AttractionPage = lazy(() => import("./pages/attractions/[slug]"));
const RodoPage = lazy(() => import("./pages/RodoPage"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/atrakcje/:slug" element={<Suspense fallback={<LoadingSpinner />}><AttractionPage /></Suspense>} />
            <Route path="/rodo" element={<Suspense fallback={<LoadingSpinner />}><RodoPage /></Suspense>} />
            <Route path="/polityka-prywatnosci" element={<Suspense fallback={<LoadingSpinner />}><PrivacyPolicyPage /></Suspense>} />
            <Route path="/regulamin" element={<Suspense fallback={<LoadingSpinner />}><TermsPage /></Suspense>} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
